import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-monitor",
  "use": "icon-monitor-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-monitor\"><path d=\"M960.8192 787.1488H73.4208V106.3424h887.3984v680.8064z m-815.7184-71.68h744.0384V178.0224H145.1008v537.4464zM259.1744 846.2336h515.84v71.68H259.1744z\" p-id=\"5327\" /><path d=\"M331.776 552.9088l-50.2272-51.0976 185.5488-182.528 115.0464 122.112 119.6032-124.4672 51.6608 49.6128-171.776 178.8416-116.48-123.648z\" p-id=\"5328\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol